// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"photos-m__wrapper__3Y2mY","title-wrapper":"photos-m__title-wrapper__gCRy-","dfp-ad-728x90":"photos-m__dfp-ad-728x90__3D-8I"};